export function getStringSizeInKb(string: string): number {
  return string.length / 1024;
}
